'use client'

import React from 'react'
import { SingleValueProps } from 'react-select'
import { Tag } from '../../../atoms'
import { SelectOption } from '../../../../types/SelectInput'

export const SingleValueTagComponent = ({ data }: SingleValueProps<SelectOption>) => {
    return (
        <Tag removable={false}>
            <div>{data.label}</div>
        </Tag>
    )
}

export const SingleValueMultiLineComponent = ({ data }: SingleValueProps<SelectOption>) => {
    return (
        <div className="truncate" data-testid="select-input-selected-value">
            {data.label}
        </div>
    )
}
